var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"color-cell"},[_c('span',{staticClass:"swatch",style:(_vm.swatchStyle)},[_vm._v(" "+_vm._s(_vm.labelTag)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }